import { BaseElementWidget, CustomWidget, SPI, ViewType } from '@kunlun/dependencies';
import FormHintBanner from './FormHintBanner.vue';

@SPI.ClassFactory(
  BaseElementWidget.Token({
    viewType: ViewType.Form,
    widget: 'SalesRatioControlFormHintBanner'
  })
)
export class SalesRatioControlFormHintBanner extends CustomWidget {
  public initialize(props) {
    super.initialize(props);
    this.setComponent(FormHintBanner);
    return this;
  }
}
